


const mixinInputOperation = {
  methods: {
    // 失焦
    onBlur: function () {
      // console.log('失焦了')
      window.scroll(0, 0)
      this.$store.commit('setFocus', false)
    },
    // 焦点
    onFocus: function (event) {
      // console.log('获取焦点')
      this.$store.commit('setFocus', true)
    }
  }
}
// 城市组件调用
import area from "@/components/common/area.vue";
import { getGlobalCities } from "@/api/m/shootCity";
const areaMixin = {
  data() {
    return {
      cityName: "",
      cityId: "",
      // 城市
      city: {
        isShow: false,
        cityData: [],
        onChoose: null,
        localCity: {},
        starCity: []
      }
    }
  },
  methods: {
    // 城市
    getCityInfo: function () {
      var self = this;
      var storage = window.sessionStorage;
      let allCityData = JSON.parse(storage.getItem("AllCityData"));
      if (allCityData) {
        self.city.cityData = allCityData;
        self.city.localCity = {
          cityId: (self.$route.query.cityId ? self.$route.query.cityId : ""),
          cityName: (self.$route.query.cityName ?
            self.$route.query.cityName :
            "选择城市"),
          citySpell: "",
          cityFirstLetter: ""
        };
        return
      }
      else {
        setTimeout(() => {
          self.getCityInfo();
        }, 200);
      }
    },
    choiceCity: function () {
      this.city.isShow = true;
    },
    close() {
      this.city.isShow = false;
    },
    // 根据城市的id返回对应的中文
    returnCityName: function (id) {
      let self = this;
      let tempCityList = self.city.cityData.allCitys.filter(w => w.id == id);
      return tempCityList[0].areaName;
    }
  },
  mounted() {
    let _this = this;
    this.getCityInfo();
    this.city.onChoose = function (res) {
      //ToDo: 选完城市后......
      // console.log(res);
      _this.city.isShow = false;
      _this.cityName = res.cityName;
      _this.cityId = res.cityId;
      _this.city.localCity = res;
    };
  },
  components: {
    city: area
  }
}

export default {
  mixinInputOperation,
  areaMixin
}



// WEBPACK FOOTER //
// ./src/assets/js/mixin.js